import { Button, Checkbox, Divider, Modal, Spin, Tag, Tree, TreeDataNode, TreeProps } from 'antd';
import { AppContextActionKeyEnum, LocationType, PaginationType } from 'types';
import styles from '../search.module.scss';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { RestAPI } from 'scripts';
import { API } from 'data';
import { TbX } from 'react-icons/tb';

export default function HeaderLocationSelectComp(props: { parentLocations?: LocationType<'list'>[] }) {
    const { locations, update } = useContext(GlobalContext);
    const [data, setData] = useState(props.parentLocations);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<LocationType<'list'>[]>([]);

    useEffect(() => {
        setSelected(locations ?? []);
    }, [locations]);

    const locationLoad: TreeProps['loadData'] = (select) => {
        return new Promise<boolean>((resolve) => {
            const parent = data?.find((i) => i.id.toString() === select.key.toString());
            RestAPI.get<PaginationType<LocationType<'list'>>>(API.location.list, {
                parent: parent?.id ?? null,
                page_size: 50,
            })
                .then((res) => {
                    setData(data ? data.concat(res.data.data) : res.data.data);
                    resolve(true);
                })
                .catch(() => resolve(false));
        });
    };

    const onLocationSelect = (value?: number) => {
        const item = data?.find((i) => i.id.toString() === value?.toString());
        let newLocations: LocationType<'list'>[] = [...selected];
        if (item) {
            const isSelected = newLocations.map((i) => i.id).includes(item.id);
            const isParentSelected = item.parent && newLocations.map((i) => i.id).includes(item.parent?.id);

            if (!isSelected && !isParentSelected) {
                newLocations = [...newLocations, item];
            }
            if (isParentSelected) {
                newLocations = [...newLocations, ...(data ?? []).filter((i) => i.parent === item.parent)];
                newLocations = newLocations.filter((i) => item.id !== i.id);
                newLocations = newLocations.filter((i) => item.parent?.id !== i.id);
            }
            if (isSelected && !isParentSelected) {
                newLocations = newLocations.filter((i) => i.id !== item.id);
            }
        } else {
            newLocations = [];
        }
        // if (locations?.map((i) => i.id).includes(Number(value))) {
        //     newLocations = locations.filter((i) => i.id !== Number(value));
        // } else {
        //     const newLocation = data?.find((i) => i.id === Number(value));
        //     if (newLocation) newLocations = locations ? locations.concat(newLocation) : [newLocation];
        // }
        setSelected(newLocations);
    };

    const parser: (i: LocationType<'list'>) => TreeDataNode = (i) => ({
        key: i.id,
        title: (
            <span
                className={`ml-2 ${selected?.map((i) => i.id).includes(i.id) || (i.parent && selected?.map((i) => i.id).includes(i.parent?.id)) ? 't-primary' : ''}`}
            >
                <Checkbox
                    className="ml-2"
                    checked={Boolean(
                        selected?.map((i) => i.id).includes(i.id) ||
                            (i.parent && selected?.map((i) => i.id).includes(i.parent?.id)),
                    )}
                />
                {i.title}
            </span>
        ),
        children: data
            ?.filter((j) => j.parent?.id === i.id)
            .sort((a, b) => a.title.localeCompare(b.title))
            .map(parser),
    });

    const parsedData = data
        ?.filter((i) => !i.parent)
        .sort((a, b) => a.title.localeCompare(b.title))
        .map(parser);

    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                closeIcon={null}
                bodyProps={{
                    style: {
                        maxHeight: '60vh',
                        overflowY: 'auto',
                    },
                }}
                footer={
                    <>
                        <Button type="text" onClick={() => setOpen(false)}>
                            لغو
                        </Button>
                        <Button
                            onClick={() => {
                                update({ key: AppContextActionKeyEnum.location, value: [] });
                                RestAPI.post(API.middlewares.location, { location: [] });
                                setOpen(false);
                            }}
                        >
                            انتخاب کل ایران
                        </Button>
                        <Button
                            onClick={() => {
                                update({ key: AppContextActionKeyEnum.location, value: selected });
                                RestAPI.post(API.middlewares.location, { location: selected });
                                setOpen(false);
                            }}
                        >
                            تایید
                        </Button>
                    </>
                }
            >
                <div>
                    {selected?.length ? (
                        <>
                            <h4 className="mb-1 t-h2 t-500">مناطق انتخاب شده:</h4>
                            <div className="d-flex flex-wrap gap-8">
                                {selected?.map((i) => (
                                    <Tag
                                        className="mt-2 pv-1 ph-2 center-content-y"
                                        key={i.id}
                                        closeIcon={<TbX className="t-l-gray1 t-d-gray3" />}
                                        onClose={() => {
                                            setSelected((e) => e.filter((j) => j.id !== i.id));
                                        }}
                                    >
                                        {i.title}
                                    </Tag>
                                ))}
                            </div>
                        </>
                    ) : null}
                    {selected?.length ? (
                        <Divider />
                    ) : (
                        <p className="mb-2 t-p1 mt-2">لطفا مناطق مورد نظر خود را انتخاب کنید:</p>
                    )}
                    <Tree
                        className={`${styles['select']}`}
                        selectedKeys={selected?.map((i) => i.id)}
                        onSelect={(a, b) => onLocationSelect(Number(b.node.key))}
                        loadData={locationLoad}
                        multiple
                        treeData={parsedData}
                        switcherLoadingIcon={<Spin size="small" />}
                    />
                </div>
            </Modal>
            <p
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpen(true);
                }}
            >
                <span className="t-gray3">|</span>
                <span className="ml-1 mr-2">
                    {locations?.length
                        ? locations.length === 1
                            ? locations.at(0)?.title
                            : 'مشاهده مناطق انتخاب شده'
                        : 'کل ایران'}
                </span>
            </p>
        </>
    );
}
